import React from "react";
import { Link } from "react-router-dom";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Clock, Mail, LogOut, CheckCircle2 } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../lib/auth";

export default function PendingApprovalPage() {
  const { lang } = useI18n();
  const { user, logout } = useAuth();

  return (
    <div className="max-w-2xl mx-auto px-4 py-16" data-testid="pending-approval-page">
      <Card className="p-8 md:p-12 text-center">
        <div className="mx-auto w-16 h-16 rounded-full bg-[#1A8FE3]/10 flex items-center justify-center mb-6">
          <Clock className="h-8 w-8 text-[#1A8FE3]" />
        </div>
        <h1 className="font-display text-3xl font-bold text-slate-900">
          {lang === "fr" ? "En attente d'approbation" : "Pending approval"}
        </h1>
        <p className="mt-4 text-slate-600 leading-relaxed">
          {lang === "fr"
            ? "Merci ! Nous avons bien reçu votre inscription. Notre équipe examine actuellement votre demande. Vous recevrez un email dès que votre compte et votre plan seront activés."
            : "Thanks! We've received your registration. Our team is reviewing your request. You'll get an email as soon as your account and plan have been activated."}
        </p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-3 text-left">
          <Step n="1" title={lang === "fr" ? "Inscription reçue" : "Registration received"} done />
          <Step n="2" title={lang === "fr" ? "Examen par un admin" : "Admin review"} active />
          <Step n="3" title={lang === "fr" ? "Compte activé" : "Account activated"} />
        </div>

        {user?.email && (
          <div className="mt-8 flex items-center justify-center gap-2 text-xs text-slate-500">
            <Mail className="h-3 w-3" />
            {lang === "fr" ? "Nous vous écrirons à" : "We'll email"} <span className="font-medium text-slate-700">{user.email}</span>
          </div>
        )}

        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button asChild variant="outline" className="rounded-full">
            <Link to="/">{lang === "fr" ? "Retour à l'accueil" : "Back to home"}</Link>
          </Button>
          <Button onClick={logout} variant="ghost" className="text-slate-500" data-testid="pending-logout">
            <LogOut className="h-4 w-4 mr-1" />{lang === "fr" ? "Se déconnecter" : "Log out"}
          </Button>
        </div>
      </Card>
    </div>
  );
}

function Step({ n, title, done, active }) {
  const cls = done ? "bg-emerald-100 text-emerald-700 border-emerald-200"
    : active ? "bg-[#1A8FE3]/10 text-[#1A8FE3] border-[#1A8FE3]/30"
    : "bg-slate-50 text-slate-400 border-slate-200";
  return (
    <div className={`rounded-xl border p-3 ${cls}`}>
      <div className="flex items-center gap-2">
        <div className={`h-6 w-6 rounded-full flex items-center justify-center text-xs font-semibold ${done ? "bg-emerald-600 text-white" : active ? "bg-[#1A8FE3] text-white" : "bg-slate-200 text-slate-500"}`}>
          {done ? <CheckCircle2 className="h-3.5 w-3.5" /> : n}
        </div>
        <span className="text-sm font-medium">{title}</span>
      </div>
    </div>
  );
}
